import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/pagatuaventura/page.tsx");
